import TransportationRequiredEntity from '../entities/TransportationRequired.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getTransportationRequireds(abortSignal: AbortSignal): Promise<Array<TransportationRequiredEntity>> {    
    return apiGet<Array<TransportationRequiredEntity>>('/transportation-required',abortSignal);
}
